import { Card, Badge, Group, Text, Stack, Grid } from '@mantine/core';
import { IconNote, IconCalendar } from '@tabler/icons-react';
import { PackageItem } from '../../types/package';

interface Props {
    packages: PackageItem[];
    statusColors: Record<string, string>;
    getCardStyle: (isReceived: boolean) => React.CSSProperties;
    getPackageStatus: (isReceived: boolean) => string;
    formatDate: (date: string) => string;
}

export function ExpectedPackagesDesktop({
    packages,
    statusColors,
    getCardStyle,
    getPackageStatus,
    formatDate
}: Props) {
    return (
        <Stack gap="md">
            {packages.map(pkg => {
                const status = getPackageStatus(pkg.isReceived);
                return (
                    <Card
                        key={pkg.id}
                        withBorder
                        radius="md"
                        p="md"
                        style={getCardStyle(pkg.isReceived)}
                        shadow="sm"
                    >
                        <Grid align="center" gutter="lg">
                            <Grid.Col span={12}>
                                <Group justify="flex-start" align="center" mb="xs">
                                    <Badge
                                        color={statusColors[status]}
                                        variant="light"
                                        size="lg"
                                        styles={{ root: { backdropFilter: 'blur(3px)', fontSize: '1rem', padding: '0.5rem 1rem' } }}
                                    >
                                        {status.charAt(0).toUpperCase() + status.slice(1)}
                                    </Badge>
                                </Group>
                                <Stack gap="xs">
                                    <Group gap={8} align="center">
                                        <IconNote
                                            size={18}
                                            style={{
                                                marginTop: 2,
                                                color: pkg.isReceived ? 'var(--mantine-color-gray-6)' : undefined
                                            }}
                                        />
                                        <Text
                                            size="lg"
                                            fw={600}
                                            style={{
                                                wordBreak: 'break-word',
                                                color: pkg.isReceived ? 'var(--mantine-color-gray-6)' : undefined
                                            }}
                                        >
                                            {pkg.note || "No description provided"}
                                        </Text>
                                    </Group>
                                    <Group gap={8} align="center">
                                        <IconCalendar
                                            size={18}
                                            style={{
                                                color: pkg.isReceived ? 'var(--mantine-color-gray-6)' : 'gray'
                                            }}
                                        />
                                        <Text
                                            size="sm"
                                            c={pkg.isReceived ? 'gray.6' : 'dimmed'}
                                        >
                                            {formatDate(pkg.created_at)}
                                        </Text>
                                    </Group>
                                </Stack>
                            </Grid.Col>
                        </Grid>
                    </Card>
                );
            })}
        </Stack>
    );
}
